{
  "main": {
    "sk": {
      "identity": {
        "version": {
          "_cldrVersion": "36"
        },
        "language": "sk"
      },
      "dates": {
        "calendars": {
          "gregorian": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "jan",
                  "2": "feb",
                  "3": "mar",
                  "4": "apr",
                  "5": "máj",
                  "6": "jún",
                  "7": "júl",
                  "8": "aug",
                  "9": "sep",
                  "10": "okt",
                  "11": "nov",
                  "12": "dec"
                },
                "narrow": {
                  "1": "j",
                  "2": "f",
                  "3": "m",
                  "4": "a",
                  "5": "m",
                  "6": "j",
                  "7": "j",
                  "8": "a",
                  "9": "s",
                  "10": "o",
                  "11": "n",
                  "12": "d"
                },
                "wide": {
                  "1": "januára",
                  "2": "februára",
                  "3": "marca",
                  "4": "apríla",
                  "5": "mája",
                  "6": "júna",
                  "7": "júla",
                  "8": "augusta",
                  "9": "septembra",
                  "10": "októbra",
                  "11": "novembra",
                  "12": "decembra"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "jan",
                  "2": "feb",
                  "3": "mar",
                  "4": "apr",
                  "5": "máj",
                  "6": "jún",
                  "7": "júl",
                  "8": "aug",
                  "9": "sep",
                  "10": "okt",
                  "11": "nov",
                  "12": "dec"
                },
                "narrow": {
                  "1": "j",
                  "2": "f",
                  "3": "m",
                  "4": "a",
                  "5": "m",
                  "6": "j",
                  "7": "j",
                  "8": "a",
                  "9": "s",
                  "10": "o",
                  "11": "n",
                  "12": "d"
                },
                "wide": {
                  "1": "január",
                  "2": "február",
                  "3": "marec",
                  "4": "apríl",
                  "5": "máj",
                  "6": "jún",
                  "7": "júl",
                  "8": "august",
                  "9": "september",
                  "10": "október",
                  "11": "november",
                  "12": "december"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "ut",
                  "wed": "st",
                  "thu": "št",
                  "fri": "pi",
                  "sat": "so"
                },
                "narrow": {
                  "sun": "n",
                  "mon": "p",
                  "tue": "u",
                  "wed": "s",
                  "thu": "š",
                  "fri": "p",
                  "sat": "s"
                },
                "short": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "ut",
                  "wed": "st",
                  "thu": "št",
                  "fri": "pi",
                  "sat": "so"
                },
                "wide": {
                  "sun": "nedeľa",
                  "mon": "pondelok",
                  "tue": "utorok",
                  "wed": "streda",
                  "thu": "štvrtok",
                  "fri": "piatok",
                  "sat": "sobota"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "ut",
                  "wed": "st",
                  "thu": "št",
                  "fri": "pi",
                  "sat": "so"
                },
                "narrow": {
                  "sun": "n",
                  "mon": "p",
                  "tue": "u",
                  "wed": "s",
                  "thu": "š",
                  "fri": "p",
                  "sat": "s"
                },
                "short": {
                  "sun": "ne",
                  "mon": "po",
                  "tue": "ut",
                  "wed": "st",
                  "thu": "št",
                  "fri": "pi",
                  "sat": "so"
                },
                "wide": {
                  "sun": "nedeľa",
                  "mon": "pondelok",
                  "tue": "utorok",
                  "wed": "streda",
                  "thu": "štvrtok",
                  "fri": "piatok",
                  "sat": "sobota"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1. štvrťrok",
                  "2": "2. štvrťrok",
                  "3": "3. štvrťrok",
                  "4": "4. štvrťrok"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1. štvrťrok",
                  "2": "2. štvrťrok",
                  "3": "3. štvrťrok",
                  "4": "4. štvrťrok"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "o poln.",
                  "am": "AM",
                  "noon": "napol.",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dopol.",
                  "afternoon1": "popol.",
                  "evening1": "večer",
                  "night1": "v noci"
                },
                "narrow": {
                  "midnight": "o poln.",
                  "am": "AM",
                  "noon": "nap.",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dop.",
                  "afternoon1": "pop.",
                  "evening1": "več.",
                  "night1": "v n."
                },
                "wide": {
                  "midnight": "o polnoci",
                  "am": "AM",
                  "noon": "napoludnie",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dopoludnia",
                  "afternoon1": "popoludní",
                  "evening1": "večer",
                  "night1": "v noci"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "poln.",
                  "am": "AM",
                  "noon": "pol.",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dopol.",
                  "afternoon1": "popol.",
                  "evening1": "večer",
                  "night1": "noc"
                },
                "narrow": {
                  "midnight": "poln.",
                  "am": "AM",
                  "noon": "pol.",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dop.",
                  "afternoon1": "pop.",
                  "evening1": "več.",
                  "night1": "noc"
                },
                "wide": {
                  "midnight": "polnoc",
                  "am": "AM",
                  "noon": "poludnie",
                  "pm": "PM",
                  "morning1": "ráno",
                  "morning2": "dopoludnie",
                  "afternoon1": "popoludnie",
                  "evening1": "večer",
                  "night1": "noc"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "pred Kristom",
                "0-alt-variant": "pred naším letopočtom",
                "1": "po Kristovi",
                "1-alt-variant": "nášho letopočtu"
              },
              "eraAbbr": {
                "0": "pred Kr.",
                "0-alt-variant": "pred n. l.",
                "1": "po Kr.",
                "1-alt-variant": "n. l."
              },
              "eraNarrow": {
                "0": "pred Kr.",
                "0-alt-variant": "pred n. l.",
                "1": "po Kr.",
                "1-alt-variant": "n. l."
              }
            },
            "dateFormats": {
              "full": "EEEE d. MMMM y",
              "long": "d. MMMM y",
              "medium": "d. M. y",
              "short": "d. M. y"
            },
            "timeFormats": {
              "full": "H:mm:ss zzzz",
              "long": "H:mm:ss z",
              "medium": "H:mm:ss",
              "short": "H:mm"
            },
            "dateTimeFormats": {
              "full": "{1}, {0}",
              "long": "{1}, {0}",
              "medium": "{1}, {0}",
              "short": "{1} {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d.",
                "E": "ccc",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "E d.",
                "Ehm": "E h:mm a",
                "EHm": "E HH:mm",
                "Ehms": "E h:mm:ss a",
                "EHms": "E HH:mm:ss",
                "Gy": "y G",
                "GyMMM": "LLLL y G",
                "GyMMMd": "d. M. y G",
                "GyMMMEd": "E d. M. y G",
                "GyMMMMd": "d. M. y G",
                "h": "h a",
                "H": "H",
                "hm": "h:mm a",
                "Hm": "H:mm",
                "hms": "h:mm:ss a",
                "Hms": "H:mm:ss",
                "hmsv": "h:mm:ss a v",
                "Hmsv": "H:mm:ss v",
                "hmv": "h:mm a v",
                "Hmv": "H:mm v",
                "M": "L.",
                "Md": "d. M.",
                "MEd": "E d. M.",
                "MMM": "LLL",
                "MMMd": "d. M.",
                "MMMEd": "E d. M.",
                "MMMMd": "d. MMMM",
                "MMMMEd": "E d. MMMM",
                "MMMMW-count-one": "W. 'týždeň' MMMM",
                "MMMMW-count-few": "W. 'týždeň' MMMM",
                "MMMMW-count-many": "W. 'týždeň' MMMM",
                "MMMMW-count-other": "W. 'týždeň' MMMM",
                "mmss": "mm:ss",
                "ms": "mm:ss",
                "y": "y",
                "yM": "M/y",
                "yMd": "d. M. y",
                "yMEd": "E d. M. y",
                "yMMM": "M/y",
                "yMMMd": "d. M. y",
                "yMMMEd": "E d. M. y",
                "yMMMM": "LLLL y",
                "yMMMMd": "d. MMMM y",
                "yQQQ": "QQQ y",
                "yQQQQ": "QQQQ y",
                "yw-count-one": "w. 'týždeň' 'roka' Y",
                "yw-count-few": "w. 'týždeň' 'roka' Y",
                "yw-count-many": "w. 'týždeň' 'roka' Y",
                "yw-count-other": "w. 'týždeň' 'roka' Y"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{1} {0}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{1} {0}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} – {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h – h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm – h:mm B",
                  "m": "h:mm – h:mm B"
                },
                "d": {
                  "d": "d. – d."
                },
                "Gy": {
                  "G": "y G – y G",
                  "y": "y – y G"
                },
                "GyM": {
                  "G": "M/y GGGGG – M/y GGGGG",
                  "M": "M/y – M/y GGGGG",
                  "y": "M/y – M/y GGGGG"
                },
                "GyMd": {
                  "d": "d. M. y – d. M. y GGGGG",
                  "G": "d. M. y GGGGG – d. M. y GGGGG",
                  "M": "d. M. y – d. M. y GGGGG",
                  "y": "d. M. y – d. M. y GGGGG"
                },
                "GyMEd": {
                  "d": "E d. M. y – E d. M. y GGGGG",
                  "G": "E d. M. y GGGGG – E d. M. y GGGGG",
                  "M": "E d. M. y – E d. M. y GGGGG",
                  "y": "E d. M. y – E d. M. y GGGGG"
                },
                "GyMMM": {
                  "G": "LLLL y G – LLLL y G",
                  "M": "LLLL – LLLL y G",
                  "y": "LLLL y – LLLL y G"
                },
                "GyMMMd": {
                  "d": "d. – d. M. y G",
                  "G": "d. M. y G – d. M. y G",
                  "M": "d. M. – d. M. y G",
                  "y": "d. M. y – d. M. y G"
                },
                "GyMMMEd": {
                  "d": "E d. M. – E d. M. y G",
                  "G": "E d. M. y G – E d. M. y G",
                  "M": "E d. M. – E d. M. y G",
                  "y": "E d. M. y – E d. M. y G"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h – h a"
                },
                "H": {
                  "H": "HH – HH"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm – h:mm a",
                  "m": "h:mm – h:mm a"
                },
                "Hm": {
                  "H": "H:mm – H:mm",
                  "m": "H:mm – H:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm – h:mm a v",
                  "m": "h:mm – h:mm a v"
                },
                "Hmv": {
                  "H": "H:mm – H:mm v",
                  "m": "H:mm – H:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h – h a v"
                },
                "Hv": {
                  "H": "HH – HH v"
                },
                "M": {
                  "M": "M. – M."
                },
                "Md": {
                  "d": "d. M. – d. M.",
                  "M": "d. M. – d. M."
                },
                "MEd": {
                  "d": "E d. M. – E d. M.",
                  "M": "E d. M. – E d. M."
                },
                "MMM": {
                  "M": "LLL – LLL"
                },
                "MMMd": {
                  "d": "d. – d. M.",
                  "M": "d. M. – d. M."
                },
                "MMMEd": {
                  "d": "E d. – E d. M.",
                  "M": "E d. M. – E d. M."
                },
                "MMMM": {
                  "M": "LLLL – LLLL"
                },
                "y": {
                  "y": "y – y"
                },
                "yM": {
                  "M": "M/y – M/y",
                  "y": "M/y – M/y"
                },
                "yMd": {
                  "d": "d. M. y – d. M. y",
                  "M": "d. M. y – d. M. y",
                  "y": "d. M. y – d. M. y"
                },
                "yMEd": {
                  "d": "E d. M. y – E d. M. y",
                  "M": "E d. M. y – E d. M. y",
                  "y": "E d. M. y – E d. M. y"
                },
                "yMMM": {
                  "M": "M – M/y",
                  "y": "M/y – M/y"
                },
                "yMMMd": {
                  "d": "d. – d. M. y",
                  "M": "d. M. – d. M. y",
                  "y": "d. M. y – d. M. y"
                },
                "yMMMEd": {
                  "d": "E d. – E d. M. y",
                  "M": "E d. M. – E d. M. y",
                  "y": "E d. M. y – E d. M. y"
                },
                "yMMMM": {
                  "M": "LLLL – LLLL y",
                  "y": "LLLL y – LLLL y"
                }
              }
            }
          }
        }
      }
    }
  }
}
